var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.$vuetify.breakpoint.smAndDown ? 'padding: 0 !important' : 'padding: 0 15% !important')},[_c('p-loader'),_vm._v(" "),_c('p-snackbar'),_vm._v(" "),_c('v-layout',[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32fb6af8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/Shared.vue
// module id = 1258
// module chunks = 1